import React, {useCallback, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { companyList, companyListActive } from "../../services/ApiServices";
import ToastMsg from "../../component/comman/ToastMsg";

const Companies = () => {
  const navigate = useNavigate();
  const [list, setList] = useState("")

  useEffect(()=>{
    getCompanies()
  },[])

  const getCompanies = () => {
    companyList()
      .then((res) => {
        if (res.status === 200) {
          setList(res.data.data);
          // console.log(res.data.data);
          
        } else {
          console.error("API response is not an array:", res?.data);
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  }

  const handleCompanyActive = (id, is_active) => {
    const data = {
      id: id,
      is_active: is_active
    };
  
    companyListActive(data)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("Details updated successfully!", "success");
        } else {
          console.error("Failed to update details:", res?.data);
          ToastMsg("Failed to update details", "error");
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };

  return (
    <>
      <section className="companies">
        <div className="card">
          <div className="card-body">
            <h4>List of all companies</h4>
            <ul>
              {list && list.map((item, index) => (
              <li className="d-flex align-items-center justify-content-between" key={item.id}>
                <div className="left d-flex align-items-center">
                  <div className="left-inner">
                    <p>{(item.name).charAt(0).toUpperCase()}</p>
                  </div>
                  <div className="left-inner-right">
                    <h3>{item.name}</h3>
                    <p>{item.company_user__email}</p>
                  </div>
                </div>
                <div className="right">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id={item.id}
                      defaultChecked={item.is_active}
                      onChange={(e) => handleCompanyActive(item.id, e.target.checked)}
                    />
                  </div>
                </div>
              </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Companies;
